import { startWebsiteCrmDemoStreamLoop } from './websiteCrmDemoStreamLoop.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession.js').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} WebsiteCrmStreamCtx
 */

/** @param {WebsiteCrmStreamCtx} ctx */
export function runWebsiteCrmDemoStream(ctx) {
  startWebsiteCrmDemoStreamLoop(ctx)
}
